/*
 * @Author: lishiqiao
 * @Date: 2022-01-17 15:26:08
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-01-17 16:03:47
 */
import http from "@/axios/index";
import Page from "@/utils/methods/page"

export default {
    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 15:44:34
     * @description: 投卵情况--查询顶级机构下的所有子机构
     * @param {*} rootId 顶级机构id
     */
    getEggCompanyList(rootId) {
        const url = `/desktopReport/querySubsidiary/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 15:45:56
     * @description: 投卵情况--查询顶级机构下的所有品类
     * @param {*} rootId
     */
    getEggBreedTypeList(rootId) {
        const url = `/desktopReport/queryPutType/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 15:52:04
     * @description: 排塘情况--查询顶级机构下的所有子机构
     * @param {*} rootId
     */
    getPondCompanyList(rootId) {
        const url = `/desktopReport/queryPaiSubsidiary/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 15:53:04
     * @description: 排塘情况--查询顶级机构下的所有批次
     * @param {*} rootId
     */
    getPondBatchList(rootId) {
        const url = `/desktopReport/queryPaiBatch/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 15:53:44
     * @description: 排塘情况--查询顶级机构下的所有品类
     * @param {*} rootId
     */
    getPondBreedTypeList(rootId) {
        const url = `/desktopReport/queryPaiType/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 15:55:03
     * @description: 排塘情况--查询顶级机构下的所有品种
     * @param {*} rootId
     */
    getPondBreedList(rootId) {
        const url = `/desktopReport/queryPaiBreed/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 16:01:28
     * @description: 投放概览-养殖投卵情况报表-育苗年份分页
     * @param {*} params
     */
    getEggPageList(params) {
        const url = `/outSeedlingDailyOrg/searchOutSeedlingDailyOrgList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 16:02:37
     * @description: 投放概览-养殖投苗、卵情况报表-（养成、育苗）分页导出
     * @param {*} params
     */
    exportEggData(params) {
        const url = `/outSeedlingDailyOrg/exportOutSeedlingDailyOrgList`;
        return Page.exportDatas(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 16:03:39
     * @description: 投放概览-排塘情况报表-养成、育苗分页
     * @param {*} params
     */
    getPondPageList(params) {
        const url = `/mdtLossOrg/searchMdtLossOrgList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-17 16:04:19
     * @description: 投放概览-排塘况报表-（养成、育苗）分页导出
     * @param {*} params
     */
    exportPondData(params) {
        const url = `/mdtLossOrg/exportMdtLossOrgList`;
        return Page.exportDatas(url, params)
    },
}